import React, {PureComponent} from "react";

class PlanBottomButton extends PureComponent {

    state = {
        planId: this.props.planId,
        price: this.props.price,
        planPeriod: this.props.planPeriod,
        selectedPlanId: this.props.selectedPlanId,
        spinnerActive: this.props.spinnerActive,
        spinnerActivePlan: this.props.spinnerActivePlan
    }


    componentDidUpdate = () => {
        if (this.state.planId !== this.props.planId) {
            this.setState({
                planId: this.props.planId
            })
        }
        if (this.state.price !== this.props.price) {
            this.setState({
                price: this.props.price
            })
        }
        if (this.state.planPeriod !== this.props.planPeriod) {
            this.setState({
                planPeriod: this.props.planPeriod
            })
        }
        if (this.state.selectedPlanId !== this.props.selectedPlanId) {
            this.setState({
                selectedPlanId: this.props.selectedPlanId
            })
        }
        if (this.state.spinnerActive !== this.props.spinnerActive) {
            this.setState({
                spinnerActive: this.props.spinnerActive
            })
        }
        if (this.state.spinnerActivePlan !== this.props.spinnerActivePlan) {
            this.setState({
                spinnerActivePlan: this.props.spinnerActivePlan
            })
        }
    }

    render() {
        const amount = this.state.planPeriod === 'monthly' ? Number(this.state.price.replace("$", "")) : Number(this.state.price.replace("$", "")) * 12
        //console.log('BottomButton amount: ', amount)
        // console.log('planBottom state: ', this.state)
        return (

            <div className="absolute bottom-0 w-full">
                <a target='_blank' href="https://emitto.io/full-plan-comparison/" className="fullPlanComparison">View
                    Full Plan
                    Comparison</a>
                <button
                    disabled={this.state.spinnerActive && this.state.spinnerActivePlan === this.state.planId}
                    onClick={
                        this.state.planId === this.state.selectedPlanId ? '' :
                            () => this.props.handlePremiumPlan(amount, this.state.planId)
                    }
                    className="getStartedSecondaryButton" id={this.state.planId.replace(/_([a-z])/g, function (g) {
                    return g[1].toUpperCase();
                }) + 'Second'}>
                    {this.state.planId === this.state.selectedPlanId ? 'Current Plan' : 'Get Started'}
                    {this.state.spinnerActive && this.state.spinnerActivePlan === this.state.planId ?
                        <i className='fa fa-spin fa-spinner'></i>
                        : ''
                    }
                </button>
            </div>
        )
    }
}

export default PlanBottomButton;